module.exports = __webpack_public_path__ + "img/Eventos_editar_formulario_azul.dc95e7b1.svg";